//@flow

import type {Pagination} from '../../entities';

export function getPaginationCount(pagination: Pagination) {
  return pagination.size >= pagination.total
    ? 1
    : Math.ceil(pagination.total / pagination.size);
}
